export default __webpack_public_path__ + "static/media/DiningRoom.4b609c3a.jpg";